var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvestments = function SvgInvestments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 65 90"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#investments_svg__a)",
    d: "M32.5 0C20.816 0 11.31 9.506 11.31 21.19s9.506 21.191 21.19 21.191 21.19-9.506 21.19-21.19S44.186 0 32.5 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#investments_svg__b)",
    d: "M49.053 65.275h-14.01V47.58a26.7 26.7 0 0 1-5.253 0v17.696H15.781a2.627 2.627 0 0 0-2.627 2.627v11.307c0 5.881 4.785 10.666 10.666 10.666h17.194c5.881 0 10.665-4.785 10.665-10.666V67.902a2.627 2.627 0 0 0-2.626-2.627"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B35DFF",
    d: "M64.23 36.9a2.63 2.63 0 0 0-1.857-.77h-.02c-.38.004-9.398.136-15.221 5.96s-5.956 14.84-5.96 15.222a2.627 2.627 0 0 0 2.628 2.646h.019c.381-.003 9.398-.136 15.222-5.96S64.997 39.159 65 38.778a2.63 2.63 0 0 0-.77-1.877M17.868 42.042c-5.823-5.823-14.84-5.956-15.222-5.959h-.02A2.625 2.625 0 0 0 0 38.729c.003.381.136 9.399 5.959 15.222s14.84 5.956 15.222 5.96h.02a2.625 2.625 0 0 0 2.626-2.647c-.003-.381-.136-9.399-5.959-15.222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFFF",
    d: "M33.983 29.18c-1.62 0-2.979-.372-4.074-1.125a7.05 7.05 0 0 1-2.489-3.011c-.559-1.259-.821-2.65-.821-4.187 0-1.61.262-3.063.799-4.352a6.64 6.64 0 0 1 2.5-3.053c1.13-.753 2.556-1.124 4.29-1.124a8.4 8.4 0 0 1 3.916.959l-.411 2.609a8.6 8.6 0 0 0-1.712-.68 6.8 6.8 0 0 0-1.85-.248c-1.574 0-2.784.505-3.606 1.516-.822 1.01-1.244 2.423-1.244 4.228 0 1.764.4 3.177 1.187 4.25s1.986 1.598 3.607 1.598c.662 0 1.3-.083 1.917-.268a8.2 8.2 0 0 0 1.735-.733l.354 2.383c-.388.31-.959.588-1.712.845a7 7 0 0 1-2.386.392"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFFF",
    d: "M35.79 18.456H23.535v1.838H35.79zM35.79 21.52H23.535v1.838H35.79z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "investments_svg__a",
    x1: 32.5,
    x2: 32.5,
    y1: 0,
    y2: 42.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7CC6",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8B08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "investments_svg__b",
    x1: 32.417,
    x2: 32.417,
    y1: 47.579,
    y2: 89.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7CC6",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8B08"
  })))));
};
export default SvgInvestments;